import { useState, useMemo, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Button } from 'foundations-components/transitional/components/Button';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function BaseRequestAdminModal({
  adminInstall,
  admins = [],
  emailAdmin,
  emailPermissionsList,
  error,
  help,
  listingId,
  loading,
  modalHeader,
  modalPermissionsList,
  onClose,
  onOpenComplete,
  onSubmit,
  subheader
}) {
  const [selectedAdmin, setSelectedAdmin] = useState(undefined);
  const adminSelect = useMemo(() => {
    const placeholder = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.productDetailsCard.cta.adminRequestModal.email.selectAdmin"
    });
    return /*#__PURE__*/_jsx(FormControl, {
      required: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.productDetailsCard.cta.adminRequestModal.email.administrator"
      }),
      children: /*#__PURE__*/_jsx(Select, {
        disabled: !!error,
        placeholder: placeholder,
        options: admins.map(admin => {
          return {
            text: `${admin.firstName} ${admin.lastName}`,
            value: admin.id
          };
        }),
        onChange: ({
          target: {
            value
          }
        }) => setSelectedAdmin(value),
        value: selectedAdmin,
        isLoading: loading
      })
    });
  }, [admins, error, loading, selectedAdmin, setSelectedAdmin]);
  const onSendEmail = useCallback(() => {
    if (selectedAdmin) {
      emailAdmin(selectedAdmin, listingId, adminInstall, emailPermissionsList);
    }
    if (onSubmit) onSubmit();
    onClose();
  }, [selectedAdmin, onSubmit, onClose, emailAdmin, listingId, adminInstall, emailPermissionsList]);
  return /*#__PURE__*/_jsxs(Modal, {
    onOpenComplete: onOpenComplete,
    width: 600,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        "aria-level": 1,
        children: modalHeader
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(H5, {
        children: subheader
      }), /*#__PURE__*/_jsx(List, {
        ordered: true,
        styled: true,
        wrapChildren: true,
        children: modalPermissionsList
      }), /*#__PURE__*/_jsx(H5, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productDetailsCard.cta.adminRequestModal.email.header"
        })
      }), help, adminSelect, error && error]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        disabled: !selectedAdmin,
        onClick: onSendEmail,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productDetailsCard.cta.adminRequestModal.send"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productDetailsCard.cta.adminRequestModal.cancel"
        })
      })]
    })]
  });
}